import React from 'react';
import { IconSvgProps } from '@models/common';

const Scan: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C14.7277 19 17.8599 16.4505 18.748 13'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.0004 20.9999L16.6504 16.6499'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.4505 2.33845C15.634 1.84291 16.3348 1.84291 16.5182 2.33845L17.5332 5.08175C17.5617 5.15873 17.6065 5.22863 17.6646 5.28665C17.7227 5.34468 17.7926 5.38946 17.8696 5.41793L20.6129 6.43291C21.1082 6.61637 21.1082 7.31718 20.6129 7.50064L17.8696 8.51562C17.7926 8.5441 17.7226 8.58891 17.6646 8.64698C17.6065 8.70504 17.5617 8.77497 17.5332 8.85199L16.5182 11.5953C16.3348 12.0906 15.634 12.0906 15.4505 11.5953L14.4355 8.85199C14.4071 8.77497 14.3622 8.70504 14.3042 8.64698C14.2461 8.58891 14.1762 8.5441 14.0992 8.51562L11.3559 7.50064C10.8605 7.31718 10.8605 6.61637 11.3559 6.43291L14.0992 5.41793C14.1762 5.38944 14.2461 5.34463 14.3042 5.28657C14.3622 5.22851 14.4071 5.15857 14.4355 5.08156L15.4505 2.33845Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Scan;
